import { Link } from "react-router-dom";
import { useT } from "../i18n";
import { appUrl } from "../lib/appUrl";
import { btnPrimaryLg, btnSecondaryLg } from "../lib/ui";

export default function CtaBand() {
  const translate = useT();

  return (
    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="cta-heading">
      <div className="relative overflow-hidden rounded-3xl bg-brand-gradient px-6 py-12 text-center shadow-glow sm:px-12 sm:py-16">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.15),transparent_60%)]" />
        <div className="relative">
          <h2 id="cta-heading" className="font-display text-3xl font-bold text-white sm:text-4xl">
            {translate("ctaTitle")}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/85 sm:text-lg">
            {translate("ctaSubtitle")}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <a
              href={appUrl("/admin/register")}
              className={`${btnPrimaryLg} bg-white text-foreground shadow-elevated hover:brightness-100 hover:bg-white/95`}
            >
              {translate("ctaButton")}
            </a>
            <span className="text-sm font-medium text-white/70">{translate("ctaContactOr")}</span>
            <Link
              to="/contact"
              className={`${btnSecondaryLg} border-white/20 bg-white/10 text-white hover:border-white/40 hover:bg-white/15`}
            >
              {translate("ctaContactLink")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
